export default __webpack_public_path__ + "static/logo_2-d2e58a4ac7e3cb93bba03e3c8d400600.jpg";